import React, { useEffect, useState } from 'react';

import './styles.css';

const BASE = `${process.env.PUBLIC_URL}/static/festival`;

// Cabecalho e rodape vem de arquivos estaticos (public/static/festival), copia
// do template do site do Festival; carregados uma vez por visita.
let cachedParts = null;

const loadParts = () =>
  Promise.all(
    ['header', 'footer'].map(part =>
      fetch(`${BASE}/${part}.html`).then(response => response.text()),
    ),
  ).then(([header, footer]) => {
    cachedParts = { header, footer };
    return cachedParts;
  });

// Os scripts do template procuram o cabecalho assim que rodam; por isso so
// entram depois de ele estar na pagina, e uma vez so (o layout nao sai da
// tela ao trocar de pagina publica).
const loadScripts = () => {
  if (window.FDR_TEMPLATE_SCRIPTS) {
    return;
  }
  window.FDR_TEMPLATE_SCRIPTS = true;

  ['main.js', 'festivaldorio.js'].reduce(
    (previous, file) =>
      previous.then(
        () =>
          new Promise(resolve => {
            const script = document.createElement('script');
            script.src = `${BASE}/js/${file}`;
            script.onload = resolve;
            script.onerror = resolve;
            document.body.appendChild(script);
          }),
      ),
    Promise.resolve(),
  );
};

/*
 * Moldura das telas publicas (credenciamento., filmes., premierebrasil.):
 * cabecalho e rodape identicos ao festivaldorio.com.br e o conteudo no meio.
 * Nada aqui usa o AdminLTE — ele nem e carregado nesses dominios
 * (public/index.html). O visual dos formularios esta em styles.css, sempre
 * dentro de .fdr-public.
 *
 * minimal (pagina de fotos do filme): so a faixa de apresentacao e a linha do
 * logo e das datas — sem menu, idiomas, RioMarket, patrocinadores e rodape
 * (regras .fdr-minimal em styles.css), e sem os scripts do menu.
 */
function PublicLayout({ children, minimal = false }) {
  const [parts, setParts] = useState(cachedParts);

  useEffect(() => {
    if (!parts) {
      loadParts()
        .then(setParts)
        .catch(() => setParts({ header: '', footer: '' }));
    }
  }, []);

  useEffect(() => {
    if (parts && parts.header && !minimal) {
      loadScripts();
    }
  }, [parts]);

  if (!parts) {
    return null;
  }

  return (
    <>
      <div
        className={minimal ? 'fdr-minimal' : undefined}
        style={{ display: 'contents' }}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: parts.header }}
      />
      <main id="conteudo" className="fdr-public">
        {children}
      </main>
      {!minimal && (
        <div
          style={{ display: 'contents' }}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: parts.footer }}
        />
      )}
    </>
  );
}

export default PublicLayout;
